type PMCustomCashIconProps = {
  className?: string;
};

const PMCustomCashIcon = ({ className }: PMCustomCashIconProps) => (
  <svg
    width="34"
    height="24"
    viewBox="0 0 34 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z"
      fill="white"
    />
    <path
      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z"
      stroke="#E4E7EC"
    />
    <g clipPath="url(#clip0_8027_10353)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1982 6.57109C16.748 6.05597 17.6068 6.06824 18.1416 6.59884L22.0102 10.4372C22.2455 10.6706 22.6254 10.6691 22.8587 10.4338C23.0921 10.1986 23.0906 9.8187 22.8554 9.58531L18.9867 5.74698C17.9935 4.76157 16.3986 4.7388 15.3777 5.69544L14.9363 6.10904C14.6945 6.33562 14.6822 6.71532 14.9088 6.95712C15.1353 7.19892 15.515 7.21127 15.7568 6.98469L16.1982 6.57109ZM11.15 10.8284C11.1377 10.8284 11.1254 10.8285 11.1132 10.8288C11.1215 10.817 11.1294 10.8048 11.137 10.7922L12.4316 8.63453C12.8137 7.9976 13.6268 7.76999 14.2841 8.11594L19.4378 10.8284H11.15ZM10.3138 10.998C10.3332 11.0097 10.353 11.0201 10.3732 11.0293C9.88221 11.3025 9.55005 11.8267 9.55005 12.4284V17.5146C9.55005 18.3983 10.2664 19.1146 11.15 19.1146H22.8501C23.7337 19.1146 24.4501 18.3983 24.4501 17.5146V12.4284C24.4501 11.5447 23.7337 10.8284 22.8501 10.8284H20.5618C20.5763 10.8077 20.5897 10.7859 20.6017 10.763C20.7561 10.4697 20.6435 10.1069 20.3502 9.95257L14.843 7.05404C13.6223 6.41156 12.1123 6.83426 11.4026 8.01713L10.108 10.1748C9.93748 10.459 10.0296 10.8275 10.3138 10.998ZM10.75 12.4284C10.75 12.2075 10.9291 12.0284 11.15 12.0284H22.8501C23.071 12.0284 23.2501 12.2075 23.2501 12.4284V17.5146C23.2501 17.7355 23.071 17.9146 22.8501 17.9146H11.15C10.9291 17.9146 10.75 17.7355 10.75 17.5146V12.4284ZM15.6914 14.4991C15.6914 13.9008 16.093 13.3963 16.6413 13.2403C16.6794 12.9457 16.9313 12.7181 17.2363 12.7181C17.5239 12.7181 17.7642 12.9204 17.8227 13.1905H18.1811C18.5125 13.1905 18.7811 13.4591 18.7811 13.7905C18.7811 14.1219 18.5125 14.3905 18.1811 14.3905H17.2363H17.0001C16.9401 14.3905 16.8914 14.4391 16.8914 14.4991C16.8914 14.5591 16.9401 14.6077 17.0001 14.6077H17.4725C18.1952 14.6077 18.7811 15.1936 18.7811 15.9164C18.7811 16.5147 18.3796 17.0192 17.8313 17.1752C17.7931 17.4698 17.5413 17.6974 17.2363 17.6974C16.9487 17.6974 16.7083 17.4951 16.6499 17.225H16.2914C15.9601 17.225 15.6914 16.9564 15.6914 16.625C15.6914 16.2936 15.9601 16.025 16.2914 16.025H17.2363H17.4725C17.5325 16.025 17.5811 15.9764 17.5811 15.9164C17.5811 15.8564 17.5325 15.8077 17.4725 15.8077H17.0001C16.2773 15.8077 15.6914 15.2219 15.6914 14.4991Z"
        fill="#0C111D"
      />
    </g>
    <defs>
      <clipPath id="clip0_8027_10353">
        <rect width="16" height="16" fill="white" transform="translate(9 4)" />
      </clipPath>
    </defs>
  </svg>
);

export default PMCustomCashIcon;
